import React, { useState } from "react"
import useStore from "../../utils/useStore"
import { CaretDown, CaretLeft, CaretRight, CaretUp } from "@phosphor-icons/react"

const QuestComponent = React.memo(({ item, isFullScreen, answers }) => {
    const selects = useStore((state) => state.selects)
    const selected = selects?.find((e) => e === item?.id)
    const editElements = useStore((state) => state.editElements)
    const addSelects = useStore((state) => state.addSelects)
    const setClickedPosition = useStore((state) => state.setClickedPosition)
    const setDragging = useStore((state) => state.setDragging)
    const dragging = useStore((state) => state.dragging)
    const setResizing = useStore((state) => state.setResizing)
    const resizing = useStore((state) => state.resizing)
    const editing = useStore((state) => state.editing)
    const setEditing = useStore((state) => state.setEditing)

    const onMouseDown = (event) => {
        if (!isFullScreen) {
            window.getSelection().removeAllRanges()
            addSelects(item?.id)
            editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
            editElements("preHeight", item?.style?.height, item?.id)
            editElements("preWidth", item?.style?.width, item?.id)
            setClickedPosition({ x: event.clientX, y: event.clientY })
            if (!selected && editing) {
                setEditing(false)
                setTimeout(() => {
                    setDragging(true)
                }, 50);
            } else if (!selected) {
                setDragging(true)
            }
        }
    }

    const onMouseHandleDown = (event, cursor, side) => {
        event.stopPropagation()
        window.getSelection().removeAllRanges()
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        setResizing({ cursor: cursor, side })
        setClickedPosition({ x: event.clientX, y: event.clientY })
    }

    const [select, setSelect] = useState(0)

    return (
        <div className={selected && !isFullScreen ? 'Presentation_Inter_Select Presentation_Inter_Selected' : isFullScreen ? 'Presentation_Inter_Select1' : 'Presentation_Inter_Select'} style={{ position: "absolute", transform: `translate(${item?.currPosition?.x}px, ${item?.currPosition?.y}px)`, pointerEvents: isFullScreen ? "none" : "", cursor: resizing ? resizing?.cursor : dragging ? "move" : "default", userSelect: "none" }} onMouseDown={onMouseDown} onClick={(event) => {
            event.stopPropagation()
            if (!selected) {
                addSelects(item?.id)
            }
        }}>
            <div style={{ ...item?.style, overflow: "hidden", pointerEvents: "none" }}>
                <div className='Presentation_Inter_Title' style={{ textAlign: "center" }}>{item?.title}</div>
                {isFullScreen ?
                    <div style={{pointerEvents: "auto"}} className={answers?.length > 0 ? "Presentation_Inter_Answer_Con" : "Presentation_Inter_Answer_Con Presentation_Inter_Answer_Con_Hide"}>
                        <div className="Presentation_Inter_Answer">{select + 1}. {answers[select]?.answer}</div>
                        <div className="Presentation_Inter_Answer_Icon_Con">
                            <CaretLeft onClick={()=>select > 0? setSelect(select - 1) : null} className="Presentation_Inter_Answer_Icon" size={18} />
                            <div className="Presentation_Inter_Answer_Num">{select+1}/{answers?.length}</div>
                            <CaretRight onClick={()=>select < answers?.length - 1 ? setSelect(select + 1) : null} className="Presentation_Inter_Answer_Icon" size={18} />
                        </div>
                    </div>
                    :
                    <div className="Presentation_Inter_Answer_Con">
                        <div className="Presentation_Inter_Answer">1. User question</div>
                        <div className="Presentation_Inter_Answer_Icon_Con">
                            <CaretLeft className="Presentation_Inter_Answer_Icon" size={18} />
                            <div className="Presentation_Inter_Answer_Num">1/10</div>
                            <CaretRight className="Presentation_Inter_Answer_Icon" size={18} />
                        </div>
                    </div>
                }
            </div>
            {selected && !dragging && !isFullScreen ?
                <>
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LT' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "top-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LB' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "bottom-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RT' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "top-right")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RB' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "bottom-right")} />
                </>
                : null}
        </div>
    )
})

export default QuestComponent;